// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reporting-container {
    margin-left: 14%;
    margin-top: 0;
}

.date-container {
    display: flex;
    justify-content: flex-start;
}

.reporting .reporting-summary {
    margin-top: 20px;
}

.reporting .reporting-card {
    background-color: #D8D8D8;
    border: 0.3px ridge #000000;
    border-radius: 6px;
    box-shadow: 0px 3px 6px #00000029;
    padding: 5px 10px 10px;
    width: 205px
}

.reporting .dashboard-param {
    margin-top: 10px;
}

.reporting .dashboard-param .nav-pills {
    border-bottom: 0.5px solid #8D8D8D;
    text-align: center;
    justify-content: center;
    align-items: center;
    opacity: 1;
}

.reporting .dashboard-param .nav-link {
    padding-right: 0;
}

.reporting .dashboard-param .nav-link.active {
    background-color: transparent;
    border-bottom: 2px solid #002E5B;
    border-radius: 0;
}

.reporting .dashboard-param .nav-link.active button {
    color: #2323E5;
}

.reporting .dashboard-param .nav-link button {
    border: 0;
    color: #8D8D8D;
    background-color: transparent;
    padding-inline: 10px;
}

.reporting .icon {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    /* margin-bottom: 10px; */
}

.reporting .icon img {
    height: 20px;
}

.reporting-card h1 {
    color: #5A5656;
    font-size: 10px;
    text-transform: uppercase;
    margin-bottom: 0;
}

.reporting-card p {
    color: #000000;
    margin-bottom: 0;
    font-weight: 600;
}

.reporting-card p span {
    font-weight: 100;
    margin-right: 2px;
}

.reporting-card .amount {
    font-size: 20px;
    margin-bottom: 10px;
}

.reporting-card h2 {
    margin-bottom: 0;
    font-size: 10px;
}

.reporting .volume {
    background-color: transparent;
}

.reporting .successful {
    background-color: #EFFCEF;
    border: 1px ridge #0C8119;
}

.reporting .successful .volume {
    background-color: transparent;
    color: #106745;
}

.reporting .failure .volume {
    background-color: transparent;
    color: #DE0000;
}

.reporting .utilize .volume {
    background-color: transparent;
    color: #2300E5;
}

.reporting .failure {
    background-color: #FFE0E0C3;
    border: 1px ridge #DE0000;
}

.reporting .utilize {
    background-color: #F4F4FF;
    border: 1px ridge #2300E5;
}

.reporting .statuses {
    background-color: #ffffff;
    border: none;
}

.reporting .vas-summary {
    background-color: #ffffff;
    border: 1px solid #E0E0E0;
    padding: 5px 8px 15px
}

.vas-summary .vas-total {
    background-color: #FAF8F4;
    box-shadow: 0px 2px 20px #00000029;
    border-radius: 6px;
    display: flex;
    padding: 20px 5px;
}

.vas-summary .vas-amount h4, h5 {
    font-size: 10px;
    margin-bottom: 0;
}

.vas-summary .vas-amount .used-amount {
    margin-bottom: 0;
}

.reporting-summary h3 {
    font-size: 12px;
    text-align: center;
    color: #000000;
}

.vas-summary .vas-amount {
    padding-inline: 10px;
    text-align: center;
}

.vas-summary .total-amount {
    border-right: 1px solid #e5e3e3;
}

.vas-summary p {
    font-weight: 600;
    color: #001C84;
    font-size: 18px;
}

.vas-summary .amount {
    font-size: 20px;
    color: #000000;
}

.reporting .status-trans {
    background-color: #ffffff;
    border: 1px solid #EAEAEA;
    border-radius: 6px;
    padding: 5px 10px 10px;
    width: 205px
}

.status-trans img {
    margin-bottom: 15px;
}

.status-trans h1 {
    font-size: 10px;
}

.status-trans p {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 5px;
}

.reporting .pending {
    color: #AA6F00;
}

.reporting .online {
    color: #1C5C53;
}

.reporting .agents {
    color: #5A5656;
}

.reporting .agents p, .wallet-trans p {
    color: #000000;
}

.reporting .wallet-trans p {
    margin-bottom: 0;
}

.reporting .wallet {
    padding: 0;
}

.reporting .wallet-trans {
    padding: 10px;
    text-align: center;
    padding: 5px 10px 0;
}

.reporting .wallet-trans h1 {
    margin-bottom: 0;
}

.status-trans .analysis {
    background-color: #F7F7F7;
    display: flex;
    height: 57px;
    border: none;
}

.reporting .chart {
    background-color: #ffffff;
    border-radius: 6px;
    padding: 60px;
    width: 637px;
    height: 370px;
}

.reporting .top-bank {
    background-color: #ffffff;
    border-radius: 6px;
    width: 205px;
    padding: 15px 10px;
    text-align: center;
    height: 370px;
}

.reporting h6 {
    font-size: 12px;
    color: #9F9F9F;
    margin-bottom: 2px;
}

.reporting .top-bank .bank-info {
    display: flex;
    gap: 5px;
}

.reporting .top-bank img {
    flex: 20% 1;
}

.reporting .top-bank .percentage {
    flex: 80% 1;
}

.reporting .top-bank .label {
    display: flex;
}

.reporting .bank-info {
    margin-top: 30px;
}

.reporting .bank-info p {
    margin-bottom: 5px;
}

.reporting .bank-info .bank-name {
    margin-right: auto;
}

.reporting .bank-info .progress {
    height: 8px;
}

.reporting .bank-info .progress-bar {
    background-color: #6AB0E6;
    border-radius: 8px;
}

.reporting .commission {
    text-align: center;
}

.reporting .commission img {
    height: 70px;
}

.reporting .commission h6 {
    margin-bottom: 0;
}

.reporting .commission p {
    font-size: 24px;
    color: #000000;
    font-weight: 100;
}

.reporting .commission span {
    font-weight: 600;
    margin-left: 3px;
}


.reporting .commission .btn {
    background-color: #060D27;
    color: #ffffff;
    border: none;
    border-radius: 12px;
    font-size: 12px;
    padding: 10px 25px;
    margin-bottom: 30px;
}

.reporting .scheme-performance {
    padding-right: 0;
}

.reporting .card-scheme {
    background-color: #ffffff;
    padding: 30px 20px;
    border-radius: 6px;
}

.reporting .card-scheme .heading {
    margin-bottom: 20px;
    color: #5A5656;
}

.reporting .card-scheme .performance {
    border-radius: 20px;
    opacity: 1;
    color: #ffffff;
    padding: 15px 10px;
}

.reporting .card-scheme .mastercard {
    background-color: #4B4B4B;
}

.reporting .card-scheme .verve {
    background-color: #00125C;
}

.reporting .card-scheme .visa {
    background-color: #483501;
}

.reporting .card-scheme .performance img {
    margin-bottom: 5px;
    height: 30px;
    margin-bottom: 15px;
}

.reporting .performance .data {
    display: flex;
    padding-left: 5px;
}

.reporting .performance-status {
    display: flex;
    gap: 15px;
}

.reporting .performance-status h6 {
    font-size: 10px;
    margin-bottom: 5px;
}

.reporting .performance-status p {
    color: #B2B2B2;
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 0;
}

.reporting .performance-status .success-value {
    border-right: 1px solid #5f5e5e;
    padding-right: 15px;
}

.reporting .performance .total-value {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 5px;
}

.reporting .performance .total-value  span {
    font-weight: 100;
    margin-right: 2px;
}

.reporting .circle-progress {
    height: 60px;
    width: 60px;
    margin-left: 40px;
}

.reporting .circle-progress .CircularProgressbar {
    height: inherit;
}

.reporting .circle-progress .CircularProgressbar .CircularProgressbar-trail {
    stroke: #000000;
}

.reporting .circle-progress .CircularProgressbar .CircularProgressbar-path {
    stroke: #d6d6d6;
}

.reporting .circle-progress .CircularProgressbar .CircularProgressbar-text {
    fill: #d6d6d6; 
}`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/reporting/Reporting.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;IAClB,iCAAiC;IACjC,sBAAsB;IACtB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAS;AACb;;AAEA;IACI,WAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;;AAGA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".reporting-container {\n    margin-left: 14%;\n    margin-top: 0;\n}\n\n.date-container {\n    display: flex;\n    justify-content: flex-start;\n}\n\n.reporting .reporting-summary {\n    margin-top: 20px;\n}\n\n.reporting .reporting-card {\n    background-color: #D8D8D8;\n    border: 0.3px ridge #000000;\n    border-radius: 6px;\n    box-shadow: 0px 3px 6px #00000029;\n    padding: 5px 10px 10px;\n    width: 205px\n}\n\n.reporting .dashboard-param {\n    margin-top: 10px;\n}\n\n.reporting .dashboard-param .nav-pills {\n    border-bottom: 0.5px solid #8D8D8D;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    opacity: 1;\n}\n\n.reporting .dashboard-param .nav-link {\n    padding-right: 0;\n}\n\n.reporting .dashboard-param .nav-link.active {\n    background-color: transparent;\n    border-bottom: 2px solid #002E5B;\n    border-radius: 0;\n}\n\n.reporting .dashboard-param .nav-link.active button {\n    color: #2323E5;\n}\n\n.reporting .dashboard-param .nav-link button {\n    border: 0;\n    color: #8D8D8D;\n    background-color: transparent;\n    padding-inline: 10px;\n}\n\n.reporting .icon {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    /* margin-bottom: 10px; */\n}\n\n.reporting .icon img {\n    height: 20px;\n}\n\n.reporting-card h1 {\n    color: #5A5656;\n    font-size: 10px;\n    text-transform: uppercase;\n    margin-bottom: 0;\n}\n\n.reporting-card p {\n    color: #000000;\n    margin-bottom: 0;\n    font-weight: 600;\n}\n\n.reporting-card p span {\n    font-weight: 100;\n    margin-right: 2px;\n}\n\n.reporting-card .amount {\n    font-size: 20px;\n    margin-bottom: 10px;\n}\n\n.reporting-card h2 {\n    margin-bottom: 0;\n    font-size: 10px;\n}\n\n.reporting .volume {\n    background-color: transparent;\n}\n\n.reporting .successful {\n    background-color: #EFFCEF;\n    border: 1px ridge #0C8119;\n}\n\n.reporting .successful .volume {\n    background-color: transparent;\n    color: #106745;\n}\n\n.reporting .failure .volume {\n    background-color: transparent;\n    color: #DE0000;\n}\n\n.reporting .utilize .volume {\n    background-color: transparent;\n    color: #2300E5;\n}\n\n.reporting .failure {\n    background-color: #FFE0E0C3;\n    border: 1px ridge #DE0000;\n}\n\n.reporting .utilize {\n    background-color: #F4F4FF;\n    border: 1px ridge #2300E5;\n}\n\n.reporting .statuses {\n    background-color: #ffffff;\n    border: none;\n}\n\n.reporting .vas-summary {\n    background-color: #ffffff;\n    border: 1px solid #E0E0E0;\n    padding: 5px 8px 15px\n}\n\n.vas-summary .vas-total {\n    background-color: #FAF8F4;\n    box-shadow: 0px 2px 20px #00000029;\n    border-radius: 6px;\n    display: flex;\n    padding: 20px 5px;\n}\n\n.vas-summary .vas-amount h4, h5 {\n    font-size: 10px;\n    margin-bottom: 0;\n}\n\n.vas-summary .vas-amount .used-amount {\n    margin-bottom: 0;\n}\n\n.reporting-summary h3 {\n    font-size: 12px;\n    text-align: center;\n    color: #000000;\n}\n\n.vas-summary .vas-amount {\n    padding-inline: 10px;\n    text-align: center;\n}\n\n.vas-summary .total-amount {\n    border-right: 1px solid #e5e3e3;\n}\n\n.vas-summary p {\n    font-weight: 600;\n    color: #001C84;\n    font-size: 18px;\n}\n\n.vas-summary .amount {\n    font-size: 20px;\n    color: #000000;\n}\n\n.reporting .status-trans {\n    background-color: #ffffff;\n    border: 1px solid #EAEAEA;\n    border-radius: 6px;\n    padding: 5px 10px 10px;\n    width: 205px\n}\n\n.status-trans img {\n    margin-bottom: 15px;\n}\n\n.status-trans h1 {\n    font-size: 10px;\n}\n\n.status-trans p {\n    font-size: 24px;\n    font-weight: 600;\n    margin-bottom: 5px;\n}\n\n.reporting .pending {\n    color: #AA6F00;\n}\n\n.reporting .online {\n    color: #1C5C53;\n}\n\n.reporting .agents {\n    color: #5A5656;\n}\n\n.reporting .agents p, .wallet-trans p {\n    color: #000000;\n}\n\n.reporting .wallet-trans p {\n    margin-bottom: 0;\n}\n\n.reporting .wallet {\n    padding: 0;\n}\n\n.reporting .wallet-trans {\n    padding: 10px;\n    text-align: center;\n    padding: 5px 10px 0;\n}\n\n.reporting .wallet-trans h1 {\n    margin-bottom: 0;\n}\n\n.status-trans .analysis {\n    background-color: #F7F7F7;\n    display: flex;\n    height: 57px;\n    border: none;\n}\n\n.reporting .chart {\n    background-color: #ffffff;\n    border-radius: 6px;\n    padding: 60px;\n    width: 637px;\n    height: 370px;\n}\n\n.reporting .top-bank {\n    background-color: #ffffff;\n    border-radius: 6px;\n    width: 205px;\n    padding: 15px 10px;\n    text-align: center;\n    height: 370px;\n}\n\n.reporting h6 {\n    font-size: 12px;\n    color: #9F9F9F;\n    margin-bottom: 2px;\n}\n\n.reporting .top-bank .bank-info {\n    display: flex;\n    gap: 5px;\n}\n\n.reporting .top-bank img {\n    flex: 20%;\n}\n\n.reporting .top-bank .percentage {\n    flex: 80%;\n}\n\n.reporting .top-bank .label {\n    display: flex;\n}\n\n.reporting .bank-info {\n    margin-top: 30px;\n}\n\n.reporting .bank-info p {\n    margin-bottom: 5px;\n}\n\n.reporting .bank-info .bank-name {\n    margin-right: auto;\n}\n\n.reporting .bank-info .progress {\n    height: 8px;\n}\n\n.reporting .bank-info .progress-bar {\n    background-color: #6AB0E6;\n    border-radius: 8px;\n}\n\n.reporting .commission {\n    text-align: center;\n}\n\n.reporting .commission img {\n    height: 70px;\n}\n\n.reporting .commission h6 {\n    margin-bottom: 0;\n}\n\n.reporting .commission p {\n    font-size: 24px;\n    color: #000000;\n    font-weight: 100;\n}\n\n.reporting .commission span {\n    font-weight: 600;\n    margin-left: 3px;\n}\n\n\n.reporting .commission .btn {\n    background-color: #060D27;\n    color: #ffffff;\n    border: none;\n    border-radius: 12px;\n    font-size: 12px;\n    padding: 10px 25px;\n    margin-bottom: 30px;\n}\n\n.reporting .scheme-performance {\n    padding-right: 0;\n}\n\n.reporting .card-scheme {\n    background-color: #ffffff;\n    padding: 30px 20px;\n    border-radius: 6px;\n}\n\n.reporting .card-scheme .heading {\n    margin-bottom: 20px;\n    color: #5A5656;\n}\n\n.reporting .card-scheme .performance {\n    border-radius: 20px;\n    opacity: 1;\n    color: #ffffff;\n    padding: 15px 10px;\n}\n\n.reporting .card-scheme .mastercard {\n    background-color: #4B4B4B;\n}\n\n.reporting .card-scheme .verve {\n    background-color: #00125C;\n}\n\n.reporting .card-scheme .visa {\n    background-color: #483501;\n}\n\n.reporting .card-scheme .performance img {\n    margin-bottom: 5px;\n    height: 30px;\n    margin-bottom: 15px;\n}\n\n.reporting .performance .data {\n    display: flex;\n    padding-left: 5px;\n}\n\n.reporting .performance-status {\n    display: flex;\n    gap: 15px;\n}\n\n.reporting .performance-status h6 {\n    font-size: 10px;\n    margin-bottom: 5px;\n}\n\n.reporting .performance-status p {\n    color: #B2B2B2;\n    font-size: 12px;\n    font-weight: 600;\n    margin-bottom: 0;\n}\n\n.reporting .performance-status .success-value {\n    border-right: 1px solid #5f5e5e;\n    padding-right: 15px;\n}\n\n.reporting .performance .total-value {\n    font-size: 20px;\n    font-weight: 600;\n    margin-bottom: 5px;\n}\n\n.reporting .performance .total-value  span {\n    font-weight: 100;\n    margin-right: 2px;\n}\n\n.reporting .circle-progress {\n    height: 60px;\n    width: 60px;\n    margin-left: 40px;\n}\n\n.reporting .circle-progress .CircularProgressbar {\n    height: inherit;\n}\n\n.reporting .circle-progress .CircularProgressbar .CircularProgressbar-trail {\n    stroke: #000000;\n}\n\n.reporting .circle-progress .CircularProgressbar .CircularProgressbar-path {\n    stroke: #d6d6d6;\n}\n\n.reporting .circle-progress .CircularProgressbar .CircularProgressbar-text {\n    fill: #d6d6d6; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
